export default class extends HTMLElement {
  connectedCallback () {
    this.addEventListener('mouseenter', this.onMouseenter)
    this.addEventListener('click', this.onClick)
  }

  disconnectedCallback () {
    this.removeEventListener('mouseenter', this.onMouseenter)
    this.removeEventListener('click', this.onClick)
  }

  onMouseenter = () => {
    this.searchModal?.init()
  }

  onClick = () => {
    this.searchModal?.openChat()
  }

  get searchModal () {
    return document.querySelector('search-modal')
  }
}
